import React from "react"

import { EditProjectOverlay } from "./EditProjectOverlay"
import { useEditProjectOverlayModel } from "./hooks/useEditProjectOverlayModel"

export interface EditProjectOverlayPayload {
  projectID: string
}

export interface EditProjectOverlayConnectorProps {
  payload: EditProjectOverlayPayload
}

export const EditProjectOverlayConnector = React.memo(
  (props: EditProjectOverlayConnectorProps) => {
    return <EditProjectOverlay {...useEditProjectOverlayModel(props)} />
  }
)

EditProjectOverlayConnector.displayName = "EditProjectOverlayConnector"

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    EDIT_PROJECT_OVERLAY: EditProjectOverlayPayload
  }
}
